/**
 * Labstep
 */

import { EntityView } from 'labstep-web/models/entity-view.model';
import React, { createContext, useState } from 'react';
import { ParamsStateContextType } from './types';

/**
 * Helper context to define if entity parameters should be persisted in Redux
 * This is because we can't store POST filter objects in history state
 */
export const ParamsStateContext =
  createContext<ParamsStateContextType>({
    entityView: undefined,
    loadedEntityView: undefined,
    setEntityView: undefined,
    entityViewUpdate: undefined,
    entityViewCreate: undefined,
    persistEntity: undefined,
    globalParams: undefined,
    initialSearchParams: undefined,
  });

export const ParamsStateContextProvider: React.FC<{
  value: ParamsStateContextType;
}> = ({ value, children }) => {
  const [entityView, setEntityView] = useState<EntityView | null>(
    null,
  );

  return (
    <ParamsStateContext.Provider
      value={{
        ...value,
        entityView,
        setEntityView,
      }}
      children={children}
    />
  );
};
